export default () => {
  const obj = JSON.parse(localStorage.getItem("authUser"))
  if (obj && obj?.data) {
    return {
      Authorization: "Bearer " + obj?.data?.Token,
    }
  } else {
    return {}
  }
}
